import { createContext } from 'react'

import { SchoolContextType } from './type'

export const SchoolContext = createContext<SchoolContextType>({})
